// src/graphql/common_deletions.js
import { gql } from "@apollo/client";

/**
 * Common Fund Deletions Query
 * 
 * Changed from quantity-based to % change based.
 * Sorted by weighted score (abs avg % change * total value).
 */
const COMMON_DELETIONS = gql`
  query GetCommonFundDeletions(
    $holdingMonth: String!
    $holdingYear: String!
    $category: String!
    $limit: Int = 25
  ) {
    getCommonFundDeletions(
      holdingMonth: $holdingMonth
      holdingYear: $holdingYear
      category: $category
      limit: $limit
    ) {
      stockName
      stockSector
      totalPercentChange
      totalValueInMn
      avgPercentChange
      weightedScore
      fundCount
      funds {
        mutualFundId
        mutualFundName
        percentChange
        valueInMn
      }
    }
  }
`;

export default COMMON_DELETIONS;
